var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1605_19377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.559 3.26352C11.9689 2.27797 13.3651 2.27797 13.775 3.26352L15.5596 7.55417C15.7324 7.96965 16.1231 8.25353 16.5716 8.28949L21.2038 8.66084C22.2677 8.74614 22.6992 10.074 21.8885 10.7684L18.3593 13.7915C18.0176 14.0842 17.8684 14.5435 17.9728 14.9813L19.051 19.5014C19.2986 20.5397 18.1691 21.3603 17.2582 20.8039L13.2925 18.3817C12.9085 18.1471 12.4255 18.1471 12.0415 18.3817L8.07576 20.8039C7.16484 21.3603 6.03534 20.5397 6.283 19.5014L7.36122 14.9813C7.46563 14.5435 7.31638 14.0842 6.97464 13.7915L3.44546 10.7684C2.63482 10.074 3.06625 8.74614 4.13023 8.66084L8.76234 8.28949C9.21089 8.25353 9.60162 7.96965 9.77443 7.55417L11.559 3.26352Z",
    fill: "#EF940B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1605_19377"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.666992,
    width: 24,
    height: 24,
    rx: 1.2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.1f9ad7f297c344d1aa945d605b898665.svg";
export { ForwardRef as ReactComponent };